import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_progress",
  "use": "micro_progress-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_progress\"><path fill-rule=\"evenodd\" d=\"M1.464 8.536A5.002 5.002 0 0 0 9.9 6H8.874a4.002 4.002 0 0 1-6.702 1.828L4 6H0v4l1.464-1.464ZM.1 4a5.002 5.002 0 0 1 8.436-2.536L10 0l-.007 4H6l1.828-1.828A4.002 4.002 0 0 0 1.126 4H.1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol